import $ from 'jquery'

$('.blog-filter-dropdown').on('change', function () {
  window.location.href = $(this).val()
})
